import moment from 'moment';
import { sanitizeScene as sanitize } from '@studio/program';

import { withCurrentParams } from 'actions/utils';
import { BROADCAST_SCENE_UPDATE } from 'actions/Types';
import { SCENE_UPDATE } from 'store/eventConstants';

/**
 * @param {string} sceneId
 * @param {{}} patch
 */
export default (sceneId, patch) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      /**
       * Deep cloning this to prevent `sanitize` method from mutating the parameter.
       * This mutation was affecting current program in state.
       */
      const clonedObject = JSON.parse(JSON.stringify(patch));
      const sanitized = sanitize(clonedObject);

      delete sanitized._id;

      const action = {
        type: BROADCAST_SCENE_UPDATE,
        loadingKey: `${BROADCAST_SCENE_UPDATE}_${sceneId}`,
        payload: {
          [sceneId]: {
            isLoading: true,
            currentTime: moment.utc().format('YYYY-MM-DD HH:mm:s')
          }
        },
        request: async apiClient => {
          const { scene } = await apiClient.broadcast.updateScene(
            teamId,
            eventId,
            broadcastId,
            sceneId,
            sanitized
          );

          const {
            meeting: { attendeeResponse }
          } = getState();

          socket.emit(SCENE_UPDATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          return { scene };
        }
      };
      dispatch(action);
    }
  );
};
